function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function waypointsEqualByValue(a, b) {
    if (a === b) return true;
    if (!a || a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i].id !== b[i].id || a[i].x !== b[i].x || a[i].y !== b[i].y) {
            return false;
        }
    }
    return true;
}
/**
 * Parallel to `PositionManager` for edge routing: holds the saved waypoint
 * sets keyed by edge, and emits whole-array `onDirty` batches whenever a
 * user action mutates them. React doesn't own this state — the adapter seeds
 * it once from the backend layout, and the control components push updates
 * on pointerup. React views pull current waypoints via `resolve(edgeKey)`
 * during edge rendering.
 *
 * Coordinate contract: waypoints are persisted in flow-space (same as node
 * positions). Endpoint coordinates come from RF live at render time, so
 * moving a source/target node moves the endpoints but leaves waypoints fixed
 * in space.
 */ export class EdgeWaypointManager {
    /** Replace the saved layer. Used when fresh layout data lands. */ setSaved(map) {
        this.saved = new Map(map);
    }
    registerMeta(key, info) {
        this.meta.set(key, info);
    }
    /** Resolve the current waypoints for an edge (empty array if none saved). */ resolve(key) {
        return this.saved.get(key) ?? [];
    }
    /**
   * Commit a single edge's waypoint array. Replaces the stored set wholesale
   * (consistent with how `stepPositions` / `generatedNodePositions` are
   * persisted — the caller always sends the full current set).
   */ commitChange(key, waypoints) {
        // Suppress no-op emissions: a drop-at-same-position drag, or an undo
        // that restores an edge to its current waypoints, shouldn't trigger a
        // network round-trip.
        if (waypointsEqualByValue(this.saved.get(key), waypoints)) return;
        this.saved.set(key, waypoints.slice());
        const m = this.meta.get(key);
        if (this.onDirty && m) {
            this.onDirty([
                {
                    key,
                    sourceNodeId: m.sourceNodeId,
                    targetNodeId: m.targetNodeId,
                    sourceHandleId: m.sourceHandleId,
                    waypoints: waypoints.slice()
                }
            ]);
        }
    }
    constructor(opts = {}){
        _define_property(this, "saved", void 0);
        _define_property(this, "meta", new Map());
        _define_property(this, "onDirty", void 0);
        this.saved = new Map(opts.initialSaved ?? new Map());
        this.onDirty = opts.onDirty;
    }
}

//# sourceMappingURL=EdgeWaypointManager.js.map